import { Styled } from "components/Styled";
import styled from "styled-components";


export const StyledButtonText = styled(Styled.ButtonText)`
font-family:'Circe', sans-serif;
`